<template>
  <el-container class="au-layout" direction="rtl">
    <el-main>
      <el-card shadow="never">
        <slot name="main"></slot>
      </el-card>
    </el-main>
    <el-aside width="360px">
      <header>
        <router-link class="box" to="/">
          <img src="@/assets/logo.png" alt="logo" width="40" height="40">
          <label>{{ title }}</label>
        </router-link>
      </header>
      <slot name="aside"></slot>
    </el-aside>
  </el-container>
</template>

<script>
/**
 * @description 布局
 * @created 2024/04/28 14:29:47
 */
export default {
  name: "AuLayout",
  props: {
    title: String
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.au-layout {
  height: 100%;
  overflow: hidden;

  .el-main {
    ::v-deep .el-card {
      height: calc(100% - 2px);

      .el-card__body {
        height: 100%;
      }
    }
  }

  .el-aside {
    header {
      padding-bottom: 20px;
      box-sizing: border-box;

      .box {
        height: 100%;
        @include flex(flex-start);

        img {
          margin-right: 10px;
        }
      }
    }

    ::v-deep .el-upload {
      width: 100%;

      .el-upload-dragger {
        width: 100%;
      }
    }

    ::v-deep .el-descriptions {
      .el-descriptions__header {
        margin-bottom: 10px;

        .el-descriptions__title {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
